import Create from 'modules/Finance/PaymentProfiles/Create/Create'

export default Create
